import { render, staticRenderFns } from "./WorkAdditionRequests.vue?vue&type=template&id=6c6b4fea&scoped=true"
import script from "./WorkAdditionRequests.vue?vue&type=script&lang=js"
export * from "./WorkAdditionRequests.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/layout/Request.css?vue&type=style&index=0&id=6c6b4fea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b4fea",
  null
  
)

export default component.exports